import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./Pages/Homepage";
import Aboutpage from "./Pages/Aboutpage";
import Eventpage from "./Pages/Eventpage";
import Gallarypage from "./Pages/Gallarypage";
import Publicationpage from "./Pages/Publicationpage";
import VissionMissionpage from "./Pages/VissionMissionpage";
import Contactpage from "./Pages/Contactpage";
import Donationpage from "./Pages/Donationpage";

import EventsClipspage from "./Pages/EventsClipspages";

import FounderPresidentpage from "./Pages/FounderPresidentpage";
import Directorpage from "./Pages/Directorpage";
import ExecutiveCommitteepage from "./Pages/ExecutiveCommitteepage";
import AdvisoryCommitteepage from "./Pages/AdvisoryCommitteepage";


function App() {
  return (
    <Router>
      <Routes>

        <Route path="/" element={<Homepage />} />
        <Route path="about/" element={<Aboutpage/>} />  
        <Route path="events/" element={<Eventpage/>} />
        <Route path="gallery/" element={<Gallarypage/>} />
         <Route path="publications/" element={<Publicationpage/>} />
        <Route path="vision-mission/" element={<VissionMissionpage/>} /> 
        <Route path="contact/" element={<Contactpage/>} />
        <Route path="donation/" element={<Donationpage/>} />

        <Route path="eventclips/" element={<EventsClipspage/>} />

          <Route path="founderpresident/" element={<FounderPresidentpage/>} />
          <Route path="director/" element={<Directorpage/>} />
          <Route path="executive-committee/" element={<ExecutiveCommitteepage/>} />
           <Route path="advisory-committee/" element={<AdvisoryCommitteepage/>} />
        </Routes>
    </Router>
  );
}

export default App;